import { all } from "redux-saga/effects";

export function* modalsSagas() {
  yield all([
    //call(onSendEmail),
  ]);
}
